const ACTIONS = {
  ADD_PAYOR: 'add payor',
  CLOSE_ADD_FORM: 'close add edit form',
  EDIT_PAYOR: 'edit payor',
  CLOSE_EDIT_FORM: 'close edit form',
  BACK_CLICK: 'back click',
}

export default ACTIONS
